var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoAgregarRojo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.08 22.82",
    style: {
      enableBackground: "new 0 0 21.08 22.82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-red{fill:#D15794;}\n\t.st1-red{enable-background:new    ;}\n\t.st2-red{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2197",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_10",
    className: "st0-red",
    d: "M5-2h11.08c2.76,0,5,2.24,5,5v12.82c0,2.76-2.24,5-5,5H5c-2.76,0-5-2.24-5-5V3 C0,0.24,2.24-2,5-2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1-red"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2-red",
    d: "M11.74,7.99h3.71v2.17h-3.71v4.23h-2.3v-4.23H5.7V7.99h3.73V4.04h2.3V7.99z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAgregarRojo);
export default __webpack_public_path__ + "static/media/icono-agregar-rojo.265bb2fc64d19656d2efb94a56438678.svg";
export { ForwardRef as ReactComponent };